export { default } from './toPairs.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/entries.js
// module id = 629
// module chunks = 67